<template>
  <div class="signature-pad">
    <canvas class="signature-pad-canvas" ref="canvas"></canvas>
  </div>
</template>

<script>
import * as SignaturePad from "signature_pad/dist/signature_pad";
import vuetifyValidationMixin from "@/mixins/has-vuetify-validations";

export default {
  name: "SignaturePad",
  props: ["value"],
  mixins: [vuetifyValidationMixin],
  mounted() {
    const canvas = this.$refs.canvas;
    this.instance = new SignaturePad(canvas);

    // we probably don't want to start with existing signature but from scratch, although
    // it is an option for future
    // if (this.value) {
    //   this.instance.fromDataURL(this.value);
    // }

    this.onResizeHandler = this.resizeCanvas.bind(this);
    window.addEventListener("resize", this.onResizeHandler);
    this.instance.onEnd = () => {
      this.$emit("input", this.instance.toDataURL());
    };
    this.resizeCanvas();
    // this is assuming it is always starting from scratch which is the case currently
    this.$emit("input", null);
  },
  beforeDestroy() {
    if (this.onResizeHandler) {
      window.removeEventListener("resize", this.onResizeHandler);
    }
  },
  methods: {
    resizeCanvas() {
      const oldData = this.instance.toData();

      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      const canvas = this.$refs.canvas;
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext("2d").scale(ratio, ratio);

      this.instance.fromData(oldData);
    }
  }
};
</script>

<style lang="sass" scoped>
.signature-pad
  width: 100%
  height: 100%
  &-canvas
    width: 100%
    height: 100%
</style>
